import { CONTACT } from "../data/site";
import { Lines, Reveal } from "./motion";
import { Cta } from "./ui-bits";

export const ContactCta = ({ n }) => (
  <section className="bg-mint px-5 py-24 text-teal sm:px-10 md:py-36 lg:px-16" data-testid="contact-cta">
    <div className="grid grid-cols-12 gap-y-12 lg:gap-x-10">
      <div className="col-span-12 lg:col-span-8">
        <Reveal>
          <p className="eyebrow flex items-center gap-3">
            {n && <span className="font-serif text-sm tracking-normal">{n}</span>}
            <span className="h-px w-8 bg-teal/50" aria-hidden="true" />Contatti
          </p>
        </Reveal>
        <Lines lines={["Hai un'attività locale", "da raccontare?", "Parliamone."]} className="mt-8 text-[2.05rem] leading-[1.06] sm:text-6xl lg:text-7xl" />
      </div>
      <Reveal delay={0.2} className="col-span-12 flex flex-col justify-end gap-8 lg:col-span-4">
        <p className="text-base leading-relaxed text-teal/90">
          Fissa una call conoscitiva con Irene o con Giulia: in 20 minuti parliamo del tuo progetto e capiamo insieme se siamo il team di lavoro giusto per il tuo business.
        </p>
        <div className="flex flex-col gap-3">
          <Cta href={CONTACT.bookingIrene} target="_blank" rel="noopener noreferrer" variant="teal" testid="cta-call-irene">20 minuti video call con Irene</Cta>
          <Cta href={CONTACT.bookingGiulia} target="_blank" rel="noopener noreferrer" variant="outline" className="!border-teal/40 !text-teal hover:!bg-teal hover:!text-mint" testid="cta-call-giulia">20 minuti video call con Giulia</Cta>
        </div>
      </Reveal>
    </div>
  </section>
);
